/**
 * @file Header.tsx
 * @author Cody Parnell
 * @description app header
 */

import { useContext } from "react";
import { Route, useLocation, Link, Switch, useHistory } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { ContextData } from "data/Context";
import GGCStoreFront from "services/ggc-storefront-api";

export default function Header() {
  let location: any = useLocation();
  let contextReact: any = useContext(ContextData);
  let history = useHistory();

  return (
    <header
      className="header-con"
      style={{
        opacity:
          window.location.pathname.indexOf("/Checkout/Finished") != -1 ||
          window.location.pathname === "/"
            ? "0"
            : "1",
      }}
    >
      <div className="headerTop">
        <div className="headerTop-logo">
          <img
            src="/images/GGC-Premium.png"
            alt=""
            className="headerTop-logoInner"
          />
        </div>
        <Route path={["/Cart"]}>
          <Link
            to="/Configurator"
            className="headerTop-backButton"
            onClick={() => {
              /**
               * checks if
               */

              if (contextReact.swiperStep === 4) {
                contextReact.backToEditor();
                contextReact.updater("swiperStep", 3);
              }

              if (contextReact.cartCount === 0) {
                contextReact.updater("swiperStep", 1);
              } else {
              }
            }}
          >
            <BackButton />
            {contextReact.swiperStep === 4 ? "Back to Add-ins" : ""}
          </Link>
        </Route>
        <Switch>
          <Route path={["/Checkout/Card"]}>
            <div
              className="headerTop-backButton"
              onClick={async () => {
                // history.push("/Checkout/Cancel");
                contextReact.updater("isFetching", true);
                GGCStoreFront.getInstance().cancelPayment(
                  GGCStoreFront.getInstance().paymentIntentID,
                  false
                );
                contextReact.updater("isFetching", false);
                history.push("/Cart");
                // history.goBack();
              }}
            >
              <BackButton />
            </div>
          </Route>
          <Route path={["/Checkout"]}>
            <div
              className="headerTop-backButton"
              onClick={() => history.goBack()}
            >
              <BackButton />
            </div>
          </Route>
        </Switch>
        <Switch>
          {/* <Route path={["/Checkout/Cancel", "/Checkout/Card"]}>
            <div
              className="headerTop-cart"
              onClick={async () => {
                contextReact.updater("isFetching", true);
                await GGCStoreFront.getInstance().cancelPayment(
                  GGCStoreFront.getInstance().paymentIntentID,
                  false
                );
                contextReact.updater("isFetching", false);
                history.push("/Cart");
              }}
            >
              <CartIcon count={contextReact.cartCount} />
            </div>
          </Route> */}
          <Route path="/Checkout">
            {/* <Link to="/Cart" className="headerTop-cart">
              <CartIcon count={contextReact.cartCount} />
            </Link> */}
          </Route>
          <Route path="/Cart">
            <Link to="/Cart" className="headerTop-cart">
              <CartIcon count={contextReact.cartCount} />
            </Link>
          </Route>
          <Route path="/">
            <Link
              to="/Cart"
              className="headerTop-cart"
              onClick={() => {
                if (
                  contextReact.currentGooGoo.name &&
                  contextReact.swiperStep === 4
                ) {
                  contextReact.addGooGooToCart();
                  // contextReact.resetConfiguratorCart();
                }
              }}
            >
              <CartIcon count={contextReact.cartCount} />
            </Link>
          </Route>
        </Switch>
      </div>
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="dialog" timeout={300}>
          <Route location={location} path={"/Configurator"}></Route>
        </CSSTransition>
      </TransitionGroup>
    </header>
  );
}

function BackButton() {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9998 2.09441C12.0044 2.64363 11.8042 3.1741 11.4398 3.5784L5.49421 10.0057L11.4328 16.4215C11.7975 16.8253 12 17.3543 12 17.9034C12 18.4525 11.7975 18.9815 11.4328 19.3852C11.2582 19.579 11.046 19.7337 10.8097 19.8395C10.5734 19.9454 10.3182 20 10.0602 20C9.80212 20 9.54689 19.9454 9.31062 19.8395C9.07434 19.7337 8.86216 19.579 8.68751 19.3852L1.36995 11.4797C1.00361 11.0773 0.800002 10.5484 0.800002 9.99926C0.800002 9.45007 1.00361 8.92122 1.36995 8.51884L8.68751 0.616132C8.86194 0.421957 9.07404 0.266911 9.31035 0.160842C9.54665 0.0547738 9.802 2.62109e-08 10.0602 2.31323e-08C10.3183 2.00537e-08 10.5737 0.0547737 10.81 0.160842C11.0463 0.266911 11.2584 0.421957 11.4328 0.616132C11.7992 1.01743 12.0019 1.54603 11.9998 2.09441Z"
        fill="#7299C6"
      />
    </svg>
  );
}

function CartIcon({ count }: any) {
  if (count === 0) {
    return (
      <div className="headerTop-cartIcon">
        <svg
          width="34"
          height="31"
          viewBox="0 0 34 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.5469 0.217285C26.9494 0.217285 26.4368 0.63983 26.3209 1.22342L26.3159 1.25005L25.8364 3.96728L2.06025 3.96728C1.49824 3.96689 0.965691 4.21862 0.609261 4.65315C0.260254 5.07862 0.11615 5.63542 0.21381 6.17563L0.220371 6.21008L2.47041 17.4602C2.64394 18.3273 3.39903 18.9539 4.27965 18.9671L4.30938 18.9673H23.1894L22.7482 21.4673H3.79688C3.11474 21.4673 2.56022 22.0137 2.54711 22.6927L2.54688 22.7173C2.54688 23.3994 3.09327 23.9539 3.77227 23.967L3.79688 23.9673H23.7969C24.3944 23.9673 24.9069 23.5447 25.0229 22.9612L25.0279 22.9345L28.5956 2.71729H32.5469C33.229 2.71729 33.7835 2.17089 33.7966 1.49188L33.7969 1.46729C33.7969 0.785148 33.2505 0.230629 32.5715 0.217522L32.5469 0.217285H27.5469ZM23.6305 16.4673H4.82141L2.82133 6.4672L25.3952 6.46728L23.6305 16.4673ZM25.0469 27.7173C25.0469 26.3366 23.9276 25.2173 22.5469 25.2173C21.1662 25.2173 20.0469 26.3366 20.0469 27.7173C20.0469 29.098 21.1662 30.2173 22.5469 30.2173C23.9276 30.2173 25.0469 29.098 25.0469 27.7173ZM7.54688 27.7173C7.54688 26.3366 6.42759 25.2173 5.04688 25.2173C3.66616 25.2173 2.54688 26.3366 2.54688 27.7173C2.54688 29.098 3.66616 30.2173 5.04688 30.2173C6.42759 30.2173 7.54688 29.098 7.54688 27.7173Z"
            fill="#E8E6DF"
          />
        </svg>
      </div>
    );
  } else {
    return (
      <div className="headerTop-cartIcon --active">
        <div className="headerTop-cartCount">{count}</div>
        <svg
          width="48"
          height="47"
          viewBox="0 0 48 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.5469 12.2173C37.9494 12.2173 37.4368 12.6398 37.3209 13.2234L37.3159 13.2501L36.8364 15.9673L13.0602 15.9673C12.4982 15.9669 11.9657 16.2186 11.6093 16.6531C11.2603 17.0786 11.1161 17.6354 11.2138 18.1756L11.2204 18.2101L13.4704 29.4602C13.6439 30.3273 14.399 30.9539 15.2796 30.9671L15.3094 30.9673H34.1894L33.7482 33.4673H14.7969C14.1147 33.4673 13.5602 34.0137 13.5471 34.6927L13.5469 34.7173C13.5469 35.3994 14.0933 35.9539 14.7723 35.967L14.7969 35.9673H34.7969C35.3944 35.9673 35.9069 35.5447 36.0229 34.9612L36.0279 34.9345L39.5956 14.7173H43.5469C44.229 14.7173 44.7835 14.1709 44.7966 13.4919L44.7969 13.4673C44.7969 12.7851 44.2505 12.2306 43.5715 12.2175L43.5469 12.2173H38.5469ZM34.6305 28.4673H15.8214L13.8213 18.4672L36.3952 18.4673L34.6305 28.4673ZM36.0469 39.7173C36.0469 38.3366 34.9276 37.2173 33.5469 37.2173C32.1662 37.2173 31.0469 38.3366 31.0469 39.7173C31.0469 41.098 32.1662 42.2173 33.5469 42.2173C34.9276 42.2173 36.0469 41.098 36.0469 39.7173ZM18.5469 39.7173C18.5469 38.3366 17.4276 37.2173 16.0469 37.2173C14.6662 37.2173 13.5469 38.3366 13.5469 39.7173C13.5469 41.098 14.6662 42.2173 16.0469 42.2173C17.4276 42.2173 18.5469 41.098 18.5469 39.7173Z"
            fill="#E31B23"
          />
          <path
            d="M25.162 12.089L25.162 12.089L25.1653 12.0827C25.3503 11.7284 25.4621 11.3397 25.4919 10.9391L25.4919 10.9391C25.5217 10.5383 25.4686 10.1368 25.337 9.75841C25.2055 9.38011 24.9988 9.03431 24.7319 8.73954C24.4676 8.44761 24.1497 8.21151 23.7978 8.04163L22.2957 7.30034L22.0276 5.71909L22.0275 5.71867C21.8923 4.92259 21.4375 4.22783 20.7864 3.77419C20.1373 3.32191 19.3386 3.13933 18.5618 3.2536L18.5598 3.25389L16.8436 3.50866L15.6212 2.34639C15.6209 2.3461 15.6206 2.34581 15.6203 2.34553C15.0446 1.79727 14.279 1.5 13.4934 1.5C12.7081 1.5 11.9427 1.79712 11.3671 2.34509C11.367 2.34516 11.3669 2.34523 11.3668 2.3453C11.3665 2.34566 11.3661 2.34603 11.3657 2.34639L10.1428 3.50911L8.42355 3.25389L8.42356 3.25388L8.41845 3.25314C7.64269 3.14071 6.84582 3.3238 6.19781 3.77528C5.54789 4.2281 5.09325 4.92094 4.95645 5.71526L4.95643 5.71526L4.95531 5.72196L4.69082 7.30035L3.17992 8.04441L3.17923 8.04475C2.46846 8.39523 1.91205 9.01149 1.65402 9.77637C1.39554 10.5426 1.46515 11.3761 1.842 12.0884C1.84244 12.0893 1.84288 12.0901 1.84333 12.091L2.58532 13.5014L1.84333 14.9118C1.84288 14.9126 1.84244 14.9134 1.842 14.9143C1.46515 15.6266 1.39554 16.4601 1.65402 17.2263C1.91205 17.9912 2.46845 18.6075 3.17923 18.958L3.17992 18.9583L4.69082 19.7024L4.9553 21.2808L4.95586 21.284C5.09115 22.0806 5.54667 22.7755 6.19874 23.2286L7.05466 21.9968L6.19874 23.2286C6.8481 23.6798 7.64657 23.8611 8.42273 23.7456C8.42358 23.7455 8.42443 23.7454 8.42528 23.7452L10.1427 23.4935L11.3671 24.6576L11.3705 24.6609C11.9466 25.2051 12.7102 25.5 13.4934 25.5C14.2767 25.5 15.0403 25.2051 15.6164 24.6609L15.6198 24.6576L16.8437 23.4939L18.5549 23.7447C18.5565 23.745 18.558 23.7452 18.5596 23.7454C19.3362 23.8622 20.1355 23.6813 20.7854 23.2297C21.4378 22.7764 21.8933 22.0808 22.0276 21.2836L22.0281 21.2806L22.2957 19.7024L23.7978 18.9611C24.1497 18.7912 24.4676 18.5551 24.7319 18.2632C24.9988 17.9684 25.2055 17.6226 25.337 17.2443C25.4686 16.8659 25.5217 16.4644 25.4919 16.0637L25.4919 16.0636C25.4621 15.6631 25.3503 15.2744 25.1653 14.92L25.1653 14.92L25.162 14.9138L24.4158 13.5014L25.162 12.089Z"
            fill="#E31B23"
            stroke="white"
            stroke-width="3"
          />
        </svg>
      </div>
    );
  }
}
